import { brandColors, colors } from "./commonStylesColor"

// 전역 공통 툴팁 스타일 토큰
export const tooltipCommonStyles = {
  blue: {
    arrow: true,
    slotProps: {
      tooltip: {
        sx: {
          bgcolor: brandColors.primary.main,
          color: colors.white,
          fontSize: 12,
          fontWeight: 500,
          px: 1.2,
          py: 0.8,
          borderRadius: "6px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          maxWidth: 360,
          whiteSpace: "pre-line",
          "&.MuiTooltip-tooltipPlacementRight": {
            marginLeft: "0px",
          },
          "&.MuiTooltip-tooltipPlacementLeft": {
            marginRight: "0px",
          },
          "&.MuiTooltip-tooltipPlacementTop": {
            marginBottom: "0px",
          },
          "&.MuiTooltip-tooltipPlacementBottom": {
            marginTop: "0px",
          },
        },
      },
      arrow: {
        sx: {
          color: brandColors.primary.main,
        },
      },
    },
  },
} as const
